// extracted by mini-css-extract-plugin
module.exports = {"verticalAlign":"Shared_verticalAlign__19Y3L"};